import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export default function FindMyShop(props){
    const { t } = useTranslation();
    return(
        <>
            {!isMobile ? <img id="find-now-image-bot" src="5379637510122105172.jpg"/> : ""}
            <div className="vertical-center-element">
                <div className="white-title-text">
                {t('Trouvez le professionnel de l’immobilier local.')}
                    </div>
                    <br/>
                <div className="white-text">
                {t('Nos experts locaux sont actifs à travers l’étendue du territoir national - également près de chez vous.')}
                    </div>
                    <br/>
                    <br/>
                    <div className="blue-button" onClick={props.showContactsClick}>{t('Trouvez nos locaux')}</div>
            </div>
            
            {isMobile ? <img id="find-now-image-bot" src="5379637510122105172.jpg"/> : ""}
        </>
    )
}
